import { apiRequest } from 'api/apiRequest'
import { getCurrentLanguage } from '../../translation'

const getInvite = (id) => apiRequest(`/v1/invite/patient?id=${id}`, { invite: {} }).get()

const sendInvite = ({ email }) => {
  const params = {
    emails: [email],
    language: getCurrentLanguage(),
  }

  return apiRequest('/v1/invite/patient/create', { error: { message: 'ERROR' } }).post(
    params
  )
}

const sendSelfInvite = ({ email, prescriberCode }) => {
  const params = { email, prescriberCode, language: getCurrentLanguage() }

  return apiRequest('/v1/invite-self/patient/create', {
    error: { message: 'ERROR' },
  }).post(params)
}

const getInvitationDoctorInfo = (invitationDoctorId) =>
  apiRequest(`/v1/invite/doctor?id=${invitationDoctorId}`).get()

const setCompletedTrainingDateOnInvitationPro = (id) =>
  apiRequest('/v1/invite/pro/update/elearning/completed').put({ id })

export const inviteApi = {
  getInvite,
  sendInvite,
  sendSelfInvite,
  getInvitationDoctorInfo,
  setCompletedTrainingDateOnInvitationPro,
}
